import { action } from '@ember/object';
import Component from '@glimmer/component';
import dateUtils from 'donor-elf-web/lib/date-utils';
import {
  AvailableOperationsByPropertyType,
  GetOperationLabel,
  type GiftHistoryVal,
  type Operation,
  type PropertyFilterInfo,
} from 'donor-elf-web/lib/filter-utils-new';
import type { SelectOption } from 'donor-elf-web/lib/form-component-utils';
import moment from 'moment';

interface ComponentArgs {
  selectedPropertyFilterInfo: PropertyFilterInfo;
  changeset: any;
  showValidationErrors: boolean;
}

export default class FilterEditGiftHistoryComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    let { changeset } = this.args;
    let giftHistoryVal = changeset.get('val') as GiftHistoryVal | undefined;
    setTimeout(() => {
      if (typeof giftHistoryVal === 'object') {
        changeset.set('giftHistoryVal', giftHistoryVal.val);
        changeset.set('giftHistoryValType', giftHistoryVal.valType);
        changeset.set('giftHistoryFrom', giftHistoryVal.from);
        changeset.set('giftHistoryTo', giftHistoryVal.to);
      } else {
        changeset.set('operation', '>=');
        changeset.set('giftHistoryVal', undefined);
        changeset.set('giftHistoryValType', 'amount');
        changeset.set(
          'giftHistoryFrom',
          moment().startOf('year').format('YYYY-MM-DD'),
        );
        changeset.set('giftHistoryTo', moment().format('YYYY-MM-DD'));
      }
    });
  }

  get showVal() {
    return this.args.changeset.get('operation') !== 'absent';
  }

  @action
  handleOperationOnChange(operation: Operation) {
    if (operation === 'absent') {
      this.args.changeset.set('giftHistoryVal', undefined);
      this.args.changeset.set('giftHistoryValType', undefined);
    }
  }

  valTypeOptions: SelectOption[] = [
    {
      val: 'amount',
      label: 'dollars',
    },
    {
      val: 'count',
      label: 'times',
    },
  ];

  get operationSelectOptions(): SelectOption[] {
    let availableOperations =
      this.args.selectedPropertyFilterInfo.availableOperations ||
      AvailableOperationsByPropertyType.giftHistory;
    return availableOperations.map((x) => {
      return {
        val: x,
        label: GetOperationLabel(x, { propertyType: 'giftHistory' }),
      };
    });
  }

  @action
  serializeDateChange(propertyName: string, val: any) {
    if (val && typeof val === 'object' && typeof val.getDate === 'function') {
      let serializedVal = dateUtils.serializeToDateOnly(val);
      this.args.changeset.set(propertyName, serializedVal);
    }
  }
}
